<template>
  <div id="dynastyBar"> </div>
</template>

<script>
export default {
  name: "ChartDynastyBar",
  props: ["templeDate"],
  data() {
    return {
      dynasty: {}, //朝代分类
    };
  },
  watch: {
    templeDate: {
      deep: true,
      handler(newVal, oldVal) {
        this.dynasty = newVal;
        this.getDynastyBAR();
      },
    },
  },
  created() {},
  mounted() {},
  computed: {
    xData() {
      return [
        this.$t("chart.song"),
        this.$t("chart.yuan"),
        this.$t("chart.ming"),
        this.$t("chart.qing"),
        this.$t("chart.min"),
        this.$t("chart.min"),
        this.$t("chart.unknow"),
      ];
    },
  },
  methods: {
    getDynastyBAR() {
      let that = this;
      let dynastyBar = this.$echarts.init(
        document.getElementById("dynastyBar")
      );
      let option;
      let dynasty = [
        this.dynasty.song,
        this.dynasty.yuan,
        this.dynasty.ming,
        this.dynasty.qing,
        this.dynasty.minguo,
        this.dynasty.xiandai,
        this.dynasty.unknow,
      ];

      //x轴
      // const xData = ["宋", "元", "明", "清", "民国", "现代", "暂不详"];
      //定义数据间隔
      const dataInterval = [0, 30, 50, 200, 500, 1000, 2000, 5000];
      const dynasty2 = [];
      for (var i = 0; i < dynasty.length; i++) {
        // 1.寻找在数据间隔里小于dynasty的最大值
        const min_v = Math.max(...dataInterval.filter((v) => v <= dynasty[i]));
        // 2.寻找在数据间隔里大于dynasty的最小值
        const max_v = Math.min(...dataInterval.filter((v) => v > dynasty[i]));
        //  3.寻找 min_v 所在的下标
        const index = dataInterval.findIndex((v) => v === min_v);
        //  4.计算该amount在y轴上应该展示的位置
        const y_value =
          ((dynasty[i] - min_v) / (max_v - min_v)) * 10 + index * 10;
        dynasty2[i] = y_value;
      }

      option = {
        title: {
          text: that.$t("chart.t4"),
        },

        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          formatter: (v) => {
            //console.log(v[0].dataIndex)
            //界面显示原数值
            return `<div>
                      <div>${that.xData[v[0].dataIndex]}</div>
                      <div> that.$t("chart.num")：${dynasty[v[0].dataIndex]}</div>
                   </div>`;
          },
        },
        // toolbox: {
        //   //echart保存为图片
        //   show: true,
        //   feature: {
        //     mark: {
        //       show: true,
        //     },
        //     // restore: {
        //     //   show: true,
        //     // },
        //     saveAsImage: {
        //       show: true,
        //       pixelRatio: 1,
        //       title: "保存为图片",
        //       type: "png",
        //       lang: ["点击保存"],
        //     },
        //   },
        // },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: that.xData,
            axisTick: {
              alignWithLabel: true,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              formatter: (v, i) => {
                if (i === 0) {
                  v = "0";
                }
                if (i === 1) {
                  v = "30";
                }
                if (i === 2) {
                  v = "50";
                }
                if (i === 3) {
                  v = "200";
                }
                if (i === 4) {
                  v = "500";
                }
                if (i === 5) {
                  v = "1000";
                }
                if (i === 6) {
                  v = "2000";
                }
                if (i === 7) {
                  v = "5000";
                }
                return v;
              },
            },
          },
        ],
        dataZoom: [
          {
            type: "inside",
          },
        ],
        series: [
          {
            itemStyle: {
              color: "rgb(90, 177, 239)",
              shadowBlur: 2,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
              normal: {
                color: function (colors) {
                  var colorList = [
                    "rgb(182, 162, 222)",
                    "rgb(255, 185, 128)",
                    "rgb(90, 177, 239)",
                    "rgb(216, 122, 128)",
                    "rgb(145, 205, 119)",
                    "rgb(229, 129, 182)",
                    "rgb(46, 199, 201)",
                  ];
                  return colorList[colors.dataIndex];
                },
              },
            },
            // 妈祖庙数量
            name: that.$t("chart.templenum"),
            type: "bar",
            barWidth: "60%",
            // label: {
            //   normal: {
            //     show: true,
            //     position: "top",
            //     formatter: function (v) {
            //       var val = v.data;
            //       return val;
            //     },
            //     color: "rgb(99, 194, 255)",
            //   },
            // },
            data: dynasty2,
          },
        ],
        animationDuration: 3000,
        anmationEasing: "cubicInOut",
      };

      option && dynastyBar.setOption(option);

      // 响应布局
      window.addEventListener("resize", () => {
        dynastyBar.resize();
      });
    },
  },
  beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
</style>
